export function Brand({ compact, light }) {
  return (
    <div className="flex flex-col leading-tight" data-testid="brand">
      <div className="flex items-center gap-2">
        <div className="h-8 w-8 rounded-lg gold-cta flex items-center justify-center font-display font-extrabold text-sm">
          EL
        </div>
        <span className={`font-display font-extrabold tracking-tight ${compact ? "text-lg" : "text-xl"} ${light ? "text-white" : "text-slate-900"}`}>
          Elite Leads
        </span>
      </div>
      {!compact && (
        <span className={`text-[11px] font-medium mt-1 ${light ? "text-amber-300/80" : "text-slate-500"}`}>
          Powered by Elite Real Estate &amp; Finance LLC
        </span>
      )}
    </div>
  );
}
